import type { CandidateProfile } from "@applicant-reviewer/api";

interface ProfileIncompleteGateProps {
  profile: CandidateProfile;
}

function getMissingFields(profile: CandidateProfile): string[] {
  const missing: string[] = [];
  if (!profile.firstName) missing.push("First name");
  if (!profile.lastName) missing.push("Last name");
  if (!profile.phone) missing.push("Phone number");
  if (!profile.idFrontMediaId) missing.push("ID front photo");
  if (!profile.idBackMediaId) missing.push("ID back photo");
  return missing;
}

export default function ProfileIncompleteGate({ profile }: ProfileIncompleteGateProps) {
  const missingFields = getMissingFields(profile);

  return (
    <div className="fixed inset-0 z-[200] bg-white flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
        <div className="flex items-center justify-center w-14 h-14 bg-amber-100 rounded-full mb-6 mx-auto">
          <svg
            className="w-7 h-7 text-amber-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            />
          </svg>
        </div>

        <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
          Complete your profile to apply
        </h2>
        <p className="text-gray-500 text-sm text-center mb-6">
          Before submitting an application, we need a few details from your profile.
        </p>

        {missingFields.length > 0 && (
          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <p className="text-sm font-medium text-gray-700 mb-3">Missing information:</p>
            <ul className="space-y-2">
              {missingFields.map((field) => (
                <li key={field} className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-1.5 h-1.5 bg-amber-400 rounded-full flex-shrink-0" />
                  {field}
                </li>
              ))}
            </ul>
          </div>
        )}

        <button
          onClick={() => {
            window.location.href = "/profile";
          }}
          className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold py-3 px-6 rounded-xl hover:opacity-90 transition-opacity"
        >
          Complete Profile
        </button>
      </div>
    </div>
  );
}
